
import clock from "./clock-regular.svg";
import clockLight from "./clock-regular-light.svg";
import crosshair from "./crosshair-solid.svg";
import download from "./file-download-solid.svg";
import ship from "./ship-solid.svg";
import layers from "./layer-group-solid.svg";
import info from "./info-circle-solid.svg";
import exclamation from "./exclamation-solid.svg";
import exclamationLight from "./exclamation-solid-light.svg";
import exclamationTriangle from "./exclamation-triangle-solid.svg";
import history from "./history-solid.svg";

const Icon = {
	clock: {
		regular: clock,
		light: clockLight
	},
	crosshair: {
		solid: crosshair
	},
	download: {
		solid: download
	},
	ship: {
		solid: ship
	},
	layerGroup: {
		solid: layers
	},
	infoCircle: {
		solid: info
	},
	exclamation: {
		solid: exclamation,
		light: exclamationLight
	},
	exclamationTriangle: {
		solid: exclamationTriangle
	},
	history: {
		solid: history
	}
};
export default Icon;
